import { createStore } from "vuex"
import authStore from "@/store/modules/auth"
import coinFlipStore from "@/store/modules/coinFlip"
import wheelOfFortuneStore from "@/store/modules/wheelOfFortune"
import gamesStore from "@/store/modules/games"
import globalStore from "@/store/modules/global"
import giveawaysStore from "./modules/giveaways"

export default createStore({
  modules: {
    auth: authStore,
    coinFlip: coinFlipStore,
    wheelOfFortune: wheelOfFortuneStore,
    games: gamesStore,
    global: globalStore,
    giveaways: giveawaysStore,
  },
})
